<template>
  <div
    class="bg-no tw-border tw-border-[#D6D6D6] tw-border-solid tw-rounded-[4px] tw-p-4 2xl:tw-p-6 tw-bg-white hover:md:tw-drop-shadow-xl tw-transition-all tw-bg-center tw-group tw-bg-no-repeat bg-partners md:tw-h-[282px] xl:tw-h-[260px] 2xl:tw-h-[320px] transition-all"
    :style="`${partnerData.logo !== null? `background-image: url('https://cms.elma365.com/assets/${partnerData.logo.id}');`: ''} ${!hovered ? '' : 'background-size: 0;'}`"
    @mouseover.stop="hovered = true" @mouseout.stop="hovered = false">
    <div class="tw-flex tw-flex-col tw-justify-between tw-items-stretch tw-h-full">
      <div class="tw-flex tw-justify-between tw-items-start md:tw-w-full">
        <span
          class="tw-hidden md:tw-inline md:tw-max-w-[55%] tw-text-[1.125rem] 2xl:tw-text-[1.5rem] tw-text-dark-blue tw-font-semibold">{{
            partnerData.name
          }}</span>
        <grade-item class="max-md:tw-hidden tw-opacity-0" :grade="translatedGrade"></grade-item>
        <span v-if="partnerData.city" class="tw-hidden tw-text-[#BABABA] tw-text-[11px]">
          <span v-if="partnerData.id === 227">{{ partnerData.city.city + ', Новосибирск' }}</span>
          <span v-else-if="partnerData.id === 252">{{ partnerData.city.city + ', Алматы' }}</span>
          <span v-else>{{ partnerData.city.city }}</span>
      </span>
      </div>
      <span class="tw-block md:tw-hidden tw-text-[1.125rem] tw-text-dark-blue tw-font-semibold tw-my-4">{{
          partnerData.name
        }}</span>
      <div>
        <div
          class="md:tw-flex tw-transition-opacity tw-ease-in-out tw-duration-300 md:tw-opacity-0 group-hover:md:tw-opacity-100">
          <div v-if="partnerData.cert && partnerData.cert !== ' '">
            <span class="tw-font-semibold tw-text-black tw-text-[12px] 2xl:tw-text-[16px]">Sertificated</span>
            <ul class="tw-list-disc max-md:tw-pl-4" style="line-height: 130%;">
              <li v-for="(item, index) in certified" :key="`certified-${index}`"
                  class="tw-text-[11px] 2xl:tw-text-[14px] first-letter:tw-uppercase md:tw-list-inside">
                <nobr>{{ item }}</nobr>
              </li>
            </ul>
          </div>
          <div v-if="partnerData.competition" class="md:tw-ml-4 2xl:tw-ml-6 tw-mt-4 md:tw-mt-0 max-md:tw-max-w-[84%]">
            <span class="tw-font-semibold tw-text-black tw-text-[12px] 2xl:tw-text-[16px]">Competitions</span>
            <ul class="tw-list-disc tw-gap-x-4" :class="{'tw-grid tw-grid-cols-2' : competencies.length > 3}"
                style="line-height: 130%;">
              <li v-for="(item1, index) in competencies" :key="`competencies-${index}`"
                  class="tw-text-[11px] 2xl:tw-text-[14px] tw-list-inside">
                <nobr>{{ item1 }}</nobr>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="tw-text-[11px] 2xl:tw-text-[14px] max-md:tw-mt-6">
        <!--        Desktop-->
        <ul
          class="max-md:tw-hidden tw-flex md:tw-justify-between md:tw-opacity-0 tw-transition-opacity tw-ease-in-out tw-duration-300 group-hover:md:tw-opacity-100">
          <li>
            <a v-if="partnerData.site" :href="partnerData.site"
               class="md:tw-opacity-0 tw-transition-opacity tw-ease-in-out tw-duration-300 group-hover:md:tw-opacity-100"
               target="_blank">{{ partnerData.site }}</a>
          </li>
          <li>
            <a v-for="(phone, index) in phones" :key="`phones-${id}-${index}`" :href="`tel:${phone}`"
               class="tw-text-black">
              {{ phone }}<span v-if="index !== phones.length - 1">;&nbsp;</span>
            </a>
          </li>
        </ul>
        <a class="max-md:tw-hidden tw-hidden tw-ml-4"
           :class="{'max-md:tw-inline-block' : phones.length >= 2 || phones[0].length > 26}"
           :href="`mailto:${partnerData.email}`">{{ partnerData.email }}</a>
        <ul
          class="max-md:tw-hidden tw-flex md:tw-justify-between md:tw-opacity-0 tw-transition-opacity tw-ease-in-out tw-duration-300 group-hover:md:tw-opacity-100">
          <li v-if="partnerData.email" class="tw-mr-4"
              :class="{'max-md:tw-hidden' : phones.length >= 2 || phones[0].length > 26}">
            <a :href="`mailto:${partnerData.email}`">{{ partnerData.email }}</a>
          </li>
          <li>
            <span>{{ partnerData.address }}</span>
          </li>
        </ul>
<!--        Mobile-->
        <div class="md:tw-hidden">
          <div class="tw-mb-2">
            <a v-for="(phone, index) in phones" :key="`phones-${id}-${index}`" :href="`tel:${phone}`"
               class="tw-text-black">
              {{ phone }}<span v-if="index !== phones.length - 1">;&nbsp;</span>
            </a>
            <span class="tw-block">{{ partnerData.address }}</span>
            <span class="tw-text-[#BABABA] tw-text-[11px] tw-block">
          {{ partnerData.city.city }}, {{ partnerData.country[0] }}
        </span>
          </div>
          <div>
            <a v-if="partnerData.email" :href="`mailto:${partnerData.email}`" class="tw-block">{{ partnerData.email }}</a>
            <a v-if="partnerData.site" :href="partnerData.site" target="_blank" class="tw-block">{{ partnerData.site }}</a>
          </div>
        </div>
        <div
          class="tw-flex tw-justify-between tw-items-end tw-w-full tw-text-[#BABABA] tw-text-[11px] 2xl:tw-text-[14px]">
          <span class="md:tw-opacity-0 tw-transition-all tw-ease-in-out tw-duration-300"
                :class="{'md:tw-opacity-100 tw-opacity-100' : hovered && partnerData.contact}">Contact&nbsp;to: {{
              partnerData.contact
            }}</span>
          <span v-if="partnerData.country" class="max-md:tw-hidden">
          <span>{{ partnerData.country[0] }}</span>
        </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GradeItem from "./GradeItem.vue";

export default {
  name: "PartnerItem",
  components: {GradeItem},
  data() {
    return {
      hovered: false
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    partnerData: {
      type: Object,
      required: true
    }
  },
  computed: {
    certified() {
      return this.partnerData.cert.replaceAll('Сертифицирован на ', '').split(' / ')
    },
    competencies() {
      return this.partnerData.competition.split(' / ')
    },
    phones() {
      return this.partnerData.phone.replaceAll(' ; ', ', ').split(', ')
    },
    translatedGrade() {
      switch (this.partnerData.grade) {
        case 'Платиновый партнер':
          return 'Platinum partner';
        case 'Золотой партнер':
          return 'Gold partner';
        case 'Серебряный партнер':
          return 'Silver partner';
        case 'Бронзовый партнер':
          return 'Bronze partner';
        case 'Сертифицированный партнер':
          return 'Sertificated partner';
        default:
          return 'Partner';
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/partners/PartnerItem.vue